import { render, staticRenderFns } from "./SubjectTeacherEdit.vue?vue&type=template&id=3bd448c0"
import script from "../../controllers/subject_teacher/subject_teacher-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject_teacher/subject_teacher-edit.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherEdit.vue?vue&type=style&index=0&id=3bd448c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports